import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions(
  {
    'ROBOT_STATUS/RESET': (state, action) => initialState,
    'ROBOT_STATUS/INIT': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        draft[robotId] = null;
      }),
    'ROBOT_STATUS/SET': (state, action) =>
      produce(state, (draft) => {
        const { robotId, data } = action.payload;

        draft[robotId] = data;
      }),
    'ROBOT_STATUS/REMOVE': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        delete draft[robotId];
      }),
  },
  initialState
);
